import * as React from 'react';
import toast, { Toaster as BaseToaster } from 'react-hot-toast';
export default toast;
export const Toaster = props => /*#__PURE__*/React.createElement(BaseToaster, props);